import { useMemo } from 'react';
import * as React from 'react';

import MultiraceLogo from '@/components/elements/Logo/MultiraceLogo';
import {
  MultiraceProgram,
  MultiraceReleaseStatus,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { multiraceProgramSelector } from '@/selectors/multiraceProgram';
import { toJapaneseNum } from '@/utility/utils';

import RaceLink from './RaceLink';
import {
  ChanceIcon,
  Container,
  DeadLine,
  EndSaleText,
  ProgramInfo,
  ProgramInfoWrapper,
  ProgramWrapper,
  RefundAmount,
  RefundText,
} from './style';

interface ProgramBoxProps {
  multiraceProgram: MultiraceProgram;
}

const ProgramBox: React.FC<ProgramBoxProps> = ({ multiraceProgram }) => {
  const getAmount = (amount: number) =>
    useMemo(() => (amount > 0 ? toJapaneseNum(amount) : 0), [amount]);

  const isSale = useMemo(
    () =>
      dayjst().isBefore(multiraceProgram.salesDeadline) &&
      !multiraceProgramSelector(multiraceProgram).isCanceled,
    [multiraceProgram],
  );

  const isReleased = useMemo(
    () => MultiraceReleaseStatus.OnSale === multiraceProgram.releaseStatus,
    [multiraceProgram],
  );

  const isShareChance = useMemo(
    () => multiraceProgram.shareCampaignAmount > multiraceProgram.refundAmount,
    [multiraceProgram],
  );

  const { isSelect } = multiraceProgramSelector(multiraceProgram);

  return (
    <Container>
      <ProgramWrapper>
        <MultiraceLogo multiraceType={multiraceProgram.multiraceType} />
        <ProgramInfoWrapper>
          {isSale ? (
            <ProgramInfo>
              <RefundText>払戻総額</RefundText>
              {isSelect && isShareChance ? (
                <RefundAmount isChance>
                  山分け
                  {getAmount(
                    Math.floor(multiraceProgram.shareCampaignAmount / 10000) *
                      10000,
                  )}
                  円
                </RefundAmount>
              ) : (
                <RefundAmount>
                  {getAmount(multiraceProgram.refundAmount)}円
                </RefundAmount>
              )}
              <DeadLine>
                締切 {multiraceProgram.salesDeadline.format('HH:mm')}
              </DeadLine>
            </ProgramInfo>
          ) : (
            <EndSaleText>終了</EndSaleText>
          )}
          {isSelect && isSale && isShareChance && <ChanceIcon />}
        </ProgramInfoWrapper>
      </ProgramWrapper>
      <RaceLink
        isSale={isSale}
        isReleased={isReleased}
        multiraceProgram={multiraceProgram}
        velodromeName={
          getVelodromeByCode(multiraceProgram.velodromeCode).romanName
        }
      />
    </Container>
  );
};

export default ProgramBox;
